<h2 mat-dialog-title>Entitlements</h2>
<mat-dialog-content class="flex gap-4 flex-col">
  @if (isLoading) {
  <ctx-loader class="flex justify-center items-center w-full"></ctx-loader>
  } @else {

  <!-- Show feature entitlements or no entitlements message -->
  @if (!featureEntitlements.length) {
  <section class="flex flex-row gap-1">
    <hlm-icon name="WARNING" inline></hlm-icon>
    <p>This license has no feature entitlements.</p>
  </section>

  } @else {
  <section class="overflow-auto max-h-96 rounded-lg" tabindex="0">
    <table
      mat-table
      class="mat-table--object"
      [dataSource]="featureEntitlements"
    >
      <!-- Properties -->
      @for (property of displayedColumns; track property; let last = $last) {
      <ng-container [matColumnDef]="property">
        <th mat-header-cell *matHeaderCellDef [ngClass]="last ? 'w-full' : ''">
          <span class="whitespace-nowrap">
            {{ getResourceDisplayName(property, projectName) }}
          </span>
        </th>
        <td
          mat-cell
          class="ph-no-capture"
          [ngClass]="last ? 'w-full' : ''"
          *matCellDef="let element"
        >
          {{ element[property] }}
        </td>
      </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>

  } }
</mat-dialog-content>
<mat-dialog-actions>
  <button ctx-button--primary matDialogClose type="button">Close</button>
</mat-dialog-actions>
